import { styled } from "@mui/material";
import { DateCalendar as MuiDateCalendarPro } from "@mui/x-date-pickers-pro";
import { calendarPickerStyle } from "../DateTimePickers.style";

/**
 * @deprecated Use DateCalendarPicker instead
 */
export const DateCalendar = styled(MuiDateCalendarPro)(calendarPickerStyle) as typeof MuiDateCalendarPro;

export default DateCalendar;
